import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { DM_Sans } from 'next/font/google'
import { MotionConfig } from 'motion/react'
import { Cursor } from '@/components/generals/cursor'
import { SmoothScroll } from '@/components/generals/smooth-scroll'
import { IntroProvider } from '@/components/generals/intro'
import { PageTransitionProvider } from '@/components/generals/page-transition'

const sans = DM_Sans({
    subsets: ['latin'],
    axes: ['opsz'],
    display: 'swap'
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${sans.style.fontFamily};--font-app-heading:${sans.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1, viewport-fit=cover' />
            </Head>

            <MotionConfig reducedMotion='user'>
                <SmoothScroll>
                    <IntroProvider>
                        <PageTransitionProvider>
                            <Component {...pageProps} />
                            <Cursor />
                            <div aria-hidden='true' className='film-grain' />
                        </PageTransitionProvider>
                    </IntroProvider>
                </SmoothScroll>
            </MotionConfig>
        </div>
    )
}

export default App
